// extracted by mini-css-extract-plugin
export default {"burgerMenuCardFrame":"burgerMenuCardFrame___wjQSi"};